import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/log.png";
import SecondNav from "./SecondNav";
import { useCart } from "../CartContext";

const Navbar = ({ menuToggler, setMenuToggler, productsQuantity }) => {
  const { cart } = useCart();
  const a = cart.reduce((sum, element) => sum + element.quantity, 0);
  const [searchInput, setSearchInput] = useState("");
  const [products, setProducts] = useState([]);
  const [filterProducts, setFilterProducts] = useState(products);
  const [loginBox, setLoginBox] = useState(false);
  const [registerBox, setRegisterBox] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    fetch("/products.json")
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, []);

  // Search Functionality
  // once i type a key it is represented as e then targeted
  const handleSearch = (e) => {
    console.log(e.target.value);
    const searchTerm = e.target.value;
    // we now assign anything we type to the value of the input:text
    setSearchInput(searchTerm);

    // filtering products based on search
    const filtered = products.filter((product) =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilterProducts(filtered);
  };

  useEffect(() => {
    if (menuToggler) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [menuToggler]);
  return (
    <div className="relative">
      {/* Desktop View */}
      <header className="shadow-sm shadow-slate-100 px-8 hidden lg:block">
        <div className="flex items-center justify-between py-6">
          <NavLink to="/">
            <img src={logo} alt="" className="h-[60px]" />
          </NavLink>
          <form className="bg-gray-100 py-3 px-5 rounded-lg flex gap-10 relative">
            <input
              type="text"
              name="search"
              id="search"
              placeholder="What are you looking for?"
              value={searchInput}
              onChange={handleSearch}
              className="bg-transparent w-[400px] outline-none focus:bg-slate-50"
            />
            <button type="submit">
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
            <div
              className={
                searchInput === ""
                  ? "hidden"
                  : "flex absolute top-[100%] left-0 bg-white shadow-sm shadow-gray-400 rounded-b-[10px] h-[auto] py-[20px] w-[100%] flex-col gap-[30px] z-[100]"
              }
            >
              {searchInput &&
                filterProducts.map((product, i) => (
                  <NavLink
                    to={`/shop/${product.id}`}
                    onClick={() => setSearchInput("")}
                    className={
                      "flex gap-3 hover:text-amber-500 py-[5px] border-b-[1px] px-[20px] border-b-gray-200 w-[100%]"
                    }
                  >
                    <img src={product.image} alt="" className="h-[50px]" />
                    <div className="">
                      <h6 className="font-[600]">{product.name}</h6>
                      <p className="text-[12px] font-[500] text-gray-500">
                        ${product.price.toFixed(2)}
                      </p>
                    </div>
                  </NavLink>
                ))}
            </div>
          </form>
          <button className="pr-3 pl-1 border-[1px] border-black rounded-full py-1 hover:bg-slate-100">
            <i className="fa-solid fa-phone bg-black text-[14px] mr-[5px] text-white p-3 rounded-full"></i>
            +234 906 835 1922
          </button>
        </div>
        <SecondNav
          productsQuantity={productsQuantity}
          loginBox={loginBox}
          registerBox={registerBox}
          setLoginBox={setLoginBox}
          setRegisterBox={setRegisterBox}
          show={show}
          setShow={setShow}
        />
      </header>

      {/* Mobile View */}
      <header className="lg:hidden px-[30px] py-[15px] flex items-center justify-between shadow-sm shadow-slate-300">
        <NavLink to="/">
          <img src={logo} alt="" className="h-[30px]" />
        </NavLink>
        <div className="grid grid-cols-3 gap-3 text-[20px]">
          <button
            onClick={() => setLoginBox(true)}
            className="hover:text-amber-500"
          >
            <i className="fa-regular fa-user"></i>
          </button>
          <NavLink to="/cart-page" className="hover:text-amber-500 relative">
            <i className="fa-solid fa-bag-shopping"></i>
            <p className="absolute top-[-10px] left-[5px] bg-black text-white h-[5px] w-[5px] flex items-center justify-center p-[10px] text-[12px] rounded-full hover:bg-amber-500">
              {a}
            </p>
          </NavLink>
          <button
            className="hover:text-amber-500"
            onClick={() => setMenuToggler(!menuToggler)}
          >
            <i className="fa-solid fa-bars"></i>
          </button>
        </div>
      </header>

      {/* mobile Nav */}
      <header
        className={`absolute top-0 right-0 bottom-0 bg-[#808080ab] backdrop-blur-[1px] block h-[130vh] lg:hidden w-[100%] z-[300] transition-all ease-in-out duration-700 overflow-auto ${
          !menuToggler
            ? "translate-x-[600px] opacity-0"
            : "translate-x-0 opacity-[1px]"
        }`}
      >
        <nav className="absolute top-0 right-0 bottom-0 bg-white h-[130vh] w-[85%] z-[300] overflow-auto px-[30px]">
          {/* Close icon */}
          <button
            onClick={() => setMenuToggler(!menuToggler)}
            className="relative top-[20px] left-[90%] text-[20px] text-gray-400"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
          <div className="pt-[30px] h-[170vh]">
            {/* Logo */}
            <NavLink to="/" onClick={() => setMenuToggler(false)}>
              <img src={logo} alt="" className="h-[35px]" />
            </NavLink>
            {/* form */}
            <form className="bg-gray-100 py-3 px-5 rounded-lg flex gap-10 my-[35px] relative">
              <input
                type="text"
                name="search"
                id="search"
                value={searchInput}
                onChange={handleSearch}
                placeholder="What are you looking for?"
                className="bg-transparent w-[400px] outline-none focus:bg-slate-50"
              />
              <button type="submit" className="relative left-[-20px]">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
              <div
                className={
                  searchInput === ""
                    ? "hidden"
                    : "flex absolute top-[100%] left-0 bg-white shadow-sm shadow-gray-400 rounded-b-[10px] h-[auto] py-[20px] w-[100%] flex-col gap-[30px] z-[100]"
                }
              >
                {searchInput &&
                  filterProducts.map((product, i) => (
                    <NavLink
                      to={`/shop/${product.id}`}
                      onClick={() => {
                        setSearchInput("");
                        setMenuToggler(false);
                      }}
                      className={
                        "flex gap-3 hover:text-amber-500 py-[5px] border-b-[1px] px-[20px] border-b-gray-200 w-[100%]"
                      }
                    >
                      <img src={product.image} alt="" className="h-[50px]" />
                      <div className="">
                        <h6 className="font-[600]">{product.name}</h6>
                        <p className="text-[12px] font-[500] text-gray-500">
                          ${product.price}.00
                        </p>
                      </div>
                    </NavLink>
                  ))}
              </div>
            </form>
            {/* Menus */}
            <div className="flex flex-col items-start gap-[15px] my-[40px]">
              <NavLink
                to="/"
                onClick={() => setMenuToggler(false)}
                className={({ isActive }) =>
                  isActive
                    ? "text-amber-500 font-[700] text-[22px]"
                    : "cursor-pointer pb-[10px] hover:text-amber-500 transition-all duration-500 ease-in-out font-[700] text-[22px]"
                }
              >
                Home
              </NavLink>
              <NavLink
                to="/shop"
                className={({ isActive }) =>
                  isActive
                    ? "text-amber-500 font-[700] text-[22px]"
                    : "cursor-pointer pb-[10px] hover:text-amber-500 relative transition-all duration-500 ease-in-out font-[700] text-[22px]"
                }
              >
                <div className="flex items-center gap-[200px] lg:gap-3">
                  <span
                    onClick={() => {
                      setMenuToggler(false);
                    }}
                  >
                    Shop{" "}
                  </span>
                </div>
              </NavLink>
              <NavLink
                to="/news"
                onClick={() => setMenuToggler(false)}
                className={({ isActive }) =>
                  isActive
                    ? "text-amber-500 font-[700] text-[22px]"
                    : "cursor-pointer pb-[10px] hover:text-amber-500 transition-all duration-500 ease-in-out font-[700] text-[22px]"
                }
              >
                News
              </NavLink>

              <NavLink
                to="/contact"
                onClick={() => setMenuToggler(false)}
                className={({ isActive }) =>
                  isActive
                    ? "text-amber-500 font-[700] text-[22px]"
                    : "cursor-pointer pb-[10px] hover:text-amber-500 transition-all duration-500 ease-in-out font-[700] text-[22px]"
                }
              >
                Contact Us
              </NavLink>
            </div>
            {/* Horizontal Line */}
            <hr className="mb-[30px]" />
            {/* Contact Details */}
            <div className="flex flex-col items-start gap-[35px]">
              <div className="flex items-center gap-[15px]">
                <div className="h-[30px] w-[30px] border-[1px] border-gray-400 rounded-full relative">
                  <i className="fa-solid fa-location-dot text-gray-400 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"></i>
                </div>
                <div>
                  <h5 className="font-[700] text-[17px] text-gray-600">
                    Address:
                  </h5>
                  <p className="text-[16px] text-gray-400">
                    No 5 Eternity Avenue
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-[15px]">
                <div className="h-[30px] w-[30px] border-[1px] border-gray-400 rounded-full relative">
                  <i className="fa-solid fa-phone-volume text-gray-400 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"></i>
                </div>
                <div>
                  <h5 className="font-[700] text-[17px] text-gray-600">
                    Phone:
                  </h5>
                  <p className="text-[16px] text-gray-400">+234-906-835-1922</p>
                </div>
              </div>
              <div className="flex items-center gap-[15px]">
                <div className="h-[30px] w-[30px] border-[1px] border-gray-400 rounded-full relative">
                  <i className="fa-brands fa-twitter text-gray-400 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"></i>
                </div>
                <div>
                  <h5 className="font-[700] text-[17px] text-gray-600">
                    Twitter:
                  </h5>
                  <p className="text-[16px] text-gray-400">
                    <a
                      href="https://x.com/ireski757"
                      className="text-amber-500"
                      onClick={() => setMenuToggler(false)}
                    >
                      ireski757
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-[15px]">
                <div className="h-[30px] w-[30px] border-[1px] border-gray-400 rounded-full relative">
                  <i className="fa-solid fa-earth-africa text-gray-400 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"></i>
                </div>
                <div>
                  <h5 className="font-[700] text-[17px] text-gray-600">
                    Website:
                  </h5>
                  <p className="text-[16px] text-gray-400">
                    <a
                      href="https://ireskitech.com/"
                      className="text-amber-500"
                      onClick={() => setMenuToggler(false)}
                    >
                      IreskiTech
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Login Box */}
      {loginBox ? (
        <div className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-[100%] w-[100%] z-50 flex items-center justify-center">
          <div
            onClick={() => setLoginBox(false)}
            className="absolute top-0 left-0 h-[100%] w-[100%] bg-[#00000099]"
          >
            <button
              onClick={() => setLoginBox(false)}
              className="absolute top-[10%] text-white left-[90%] text-[30px]"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div className="relative z-50 bg-white w-[400px] py-[50px] px-[40px] rounded-[5px]">
            <form>
              <div className="my-[10px]">
                <label htmlFor="username" className="text-gray-500">
                  Username
                </label>
                <input
                  type="text"
                  name="Username"
                  id="username"
                  className="h-[45px] w-[100%] bg-gray-200 mt-[5px] rounded-[5px] pl-[15px] text-gray-600"
                  required
                />
              </div>
              <div className="mt-[30px] relative">
                <label htmlFor="password" className="text-gray-500">
                  Password
                </label>
                <input
                  type={`${show ? "password" : "text"}`}
                  name="Password"
                  id="password"
                  className="h-[45px] w-[100%] bg-gray-200 mt-[5px] rounded-[5px] pl-[15px] text-gray-600"
                  required
                />
                {show ? (
                  <div
                    id="eye"
                    className="absolute top-[50%] left-[92%] text-gray-600"
                    onClick={() => setShow(false)}
                  >
                    <i className="fa-solid fa-eye"></i>
                  </div>
                ) : (
                  <div
                    id="eye"
                    className="absolute top-[50%] left-[92%] text-gray-600"
                    onClick={() => setShow(true)}
                  >
                    <i className="fa-solid fa-eye-slash"></i>
                  </div>
                )}
              </div>
              <div className="mt-[30px] flex items-center justify-between text-gray-500">
                <div className="flex items-center gap-2">
                  <input type="checkbox" name="Check" id="check" />
                  <label htmlFor="check">Remember Me</label>
                </div>
                <div className="hover:text-amber-500">Forgot password?</div>
              </div>

              <input
                type="submit"
                value="Log In"
                className="text-white font-[600] bg-gray-900 py-[10px] w-[100%] mt-[30px] rounded-[5px] hover:bg-amber-500 hover:text-black cursor-pointer"
              />
              <p className="mt-[20px]">
                Don't have account?{" "}
                <button
                  className="hover:text-amber-500"
                  onClick={() => {
                    setRegisterBox(true);
                    setLoginBox(false);
                  }}
                >
                  Register Here
                </button>
              </p>
            </form>
          </div>
        </div>
      ) : (
        ""
      )}

      {registerBox ? (
        <div className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-[100%] w-[100%] z-50 flex items-center justify-center">
          <div
            onClick={() => setRegisterBox(false)}
            className="absolute top-0 left-0 h-[100%] w-[100%] bg-[#00000099]"
          >
            <button
              onClick={() => setRegisterBox(false)}
              className="absolute top-[4%] text-white left-[90%] text-[30px]"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div className="relative z-50 bg-white w-[400px] py-[50px] px-[40px] rounded-[5px]">
            <form>
              <div className="my-[10px]">
                <label htmlFor="username" className="text-gray-500">
                  Full Name
                </label>
                <input
                  type="text"
                  name="Username"
                  id="username"
                  className="h-[45px] w-[100%] bg-gray-200 mt-[5px] rounded-[5px] pl-[15px] text-gray-600"
                  required
                />
              </div>
              <div className="my-[10px]">
                <label htmlFor="email" className="text-gray-500">
                  E-mail
                </label>
                <input
                  type="email"
                  name="Email"
                  id="email"
                  className="h-[45px] w-[100%] bg-gray-200 mt-[5px] rounded-[5px] pl-[15px] text-gray-600"
                  required
                />
              </div>
              <div className="mt-[30px] relative">
                <label htmlFor="password" className="text-gray-500">
                  Password
                </label>
                <input
                  type={`${show ? "password" : "text"}`}
                  name="Password"
                  id="password"
                  className="h-[45px] w-[100%] bg-gray-200 mt-[5px] rounded-[5px] pl-[15px] text-gray-600"
                  required
                />
                {show ? (
                  <div
                    id="eye"
                    className="absolute top-[50%] left-[92%] text-gray-600"
                    onClick={() => setShow(false)}
                  >
                    <i className="fa-solid fa-eye"></i>
                  </div>
                ) : (
                  <div
                    id="eye"
                    className="absolute top-[50%] left-[92%] text-gray-600"
                    onClick={() => setShow(true)}
                  >
                    <i className="fa-solid fa-eye-slash"></i>
                  </div>
                )}
              </div>

              <input
                type="submit"
                value="Register Now"
                className="text-white font-[600] bg-gray-900 py-[10px] w-[100%] mt-[30px] rounded-[5px] hover:bg-amber-500 hover:text-black cursor-pointer"
              />
              <p className="mt-[20px]">
                Already have an account?{" "}
                <button
                  className="hover:text-amber-500"
                  onClick={() => {
                    setRegisterBox(false);
                    setLoginBox(true);
                  }}
                >
                  Login Here
                </button>
              </p>
            </form>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Navbar;
